// แปลรับรอง × ประเภทเอกสาร — landing data (TH/EN)
// อ้างอิงกรอบงาน: กองสัญชาติและนิติกรณ์ กรมการกงสุล กระทรวงการต่างประเทศ (consular.mfa.go.th)
// สถานะ Apostille: ไทยยื่นภาคยานุวัติสาร 30 มิ.ย. 2569 (2026) อนุสัญญามีผลกับไทย 28 ก.พ. 2570 (2027) — hcch.net

export interface TranslationDocLanding {
  slug: string;
  titleTh: string;
  titleEn: string;
  /** ชื่อเอกสาร/แบบฟอร์มทางการ */
  officialTh: string;
  officialEn: string;
  /** ระบบการรับรองคำแปลที่มักถูกกำหนด */
  certSystemTh: string;
  certSystemEn: string;
  useCaseTh: string;
  useCaseEn: string;
  prepareTh: string[];
  prepareEn: string[];
  pitfallsTh: string[];
  pitfallsEn: string[];
  nextStepTh: string;
  nextStepEn: string;
  turnaroundTh: string;
  turnaroundEn: string;
}

const D = (d: TranslationDocLanding): TranslationDocLanding => d;

export const TRANSLATION_DOC_LANDINGS: TranslationDocLanding[] = [
  D({
    slug: "birth-certificate",
    titleTh: "แปลสูติบัตร (Birth Certificate)",
    titleEn: "Certified Translation of a Thai Birth Certificate",
    officialTh: "สูติบัตร (ท.ร.1 / ท.ร.19) ฉบับคัดรับรองจากสำนักทะเบียนอำเภอหรือเขต",
    officialEn: "Thai birth certificate (Tor Ror 1 / Tor Ror 19), freshly certified extract from the district registrar",
    certSystemTh:
      "ไทย→อังกฤษ: คำรับรองคำแปลของผู้แปล + นิติกรณ์กรมการกงสุล · ออสเตรเลีย/นิวซีแลนด์: NAATI · เยอรมนี/ฝรั่งเศส/สเปน/อิตาลี: sworn translator ของประเทศนั้น",
    certSystemEn:
      "Thai→English: translator's certificate of accuracy plus MFA legalisation. Australia/New Zealand: NAATI. Germany, France, Spain, Italy: a sworn translator registered with that country's court.",
    useCaseTh:
      "ใช้ยื่นวีซ่าติดตามครอบครัว ขอสัญชาติหรือหนังสือเดินทางต่างประเทศให้บุตร จดทะเบียนเกิดที่สถานทูต สมัครเรียนต่างประเทศ และยื่นต่อนายทะเบียนราษฎรของประเทศปลายทาง",
    useCaseEn:
      "Used for dependent and family visas, registering a child's foreign citizenship or passport, school enrolment abroad, and submissions to foreign civil registries.",
    prepareTh: [
      "สูติบัตรฉบับคัดรับรองใหม่จากอำเภอ/เขต (หลายปลายทางรับเฉพาะฉบับที่ออกไม่เกิน 3–6 เดือน)",
      "สำเนาหนังสือเดินทางของเด็กและบิดามารดา เพื่อล็อกตัวสะกดชื่อให้ตรงกัน",
      "ระบุประเทศและหน่วยงานปลายทาง เพื่อเลือกระบบรับรองคำแปลให้ถูก",
    ],
    prepareEn: [
      "A freshly certified extract from the district office (many authorities accept only 3–6 month old copies)",
      "Passport copies of the child and both parents so name spellings match exactly",
      "The destination country and receiving authority, so the correct certification system is used",
    ],
    pitfallsTh: [
      "ใช้สำเนาถ่ายเอกสารแทนฉบับคัดรับรอง — กงสุลและปลายทางไม่รับ",
      "ตัวสะกดชื่อบิดามารดาไม่ตรงหนังสือเดินทาง",
      "ไม่ได้แปลตราประทับ ลายเซ็นนายทะเบียน และข้อความด้านหลังเอกสาร",
      "ใช้ระบบรับรองผิดประเทศ เช่น ส่งคำแปลที่รับรองในไทยไปยื่นหน่วยงานออสเตรเลียซึ่งกำหนด NAATI",
    ],
    pitfallsEn: [
      "Submitting a photocopy instead of a certified extract",
      "Parent name spellings that differ from the passports",
      "Leaving seals, registrar signatures and reverse-side text untranslated",
      "Using the wrong certification system for the destination (for example a Thailand-stamped translation for an Australian authority that requires NAATI)",
    ],
    nextStepTh:
      "หลังแปลและรับรองคำแปล นำเข้านิติกรณ์ที่กองสัญชาติและนิติกรณ์ กรมการกงสุล จากนั้นรับรองต่อที่สถานทูตปลายทางในไทย (จนกว่าอนุสัญญา Apostille จะมีผลกับไทยในวันที่ 28 กุมภาพันธ์ 2570)",
    nextStepEn:
      "After translation and certification, legalise at the Department of Consular Affairs and then at the destination embassy in Thailand, until the Apostille Convention takes effect for Thailand on 28 February 2027.",
    turnaroundTh: "แปล 1–2 วันทำการ · นิติกรณ์กรมการกงสุลเพิ่ม 2–3 วันทำการ (ไม่รวมคิวสถานทูต)",
    turnaroundEn: "1–2 working days for translation; MFA legalisation adds 2–3 working days, excluding embassy queues.",
  }),
  D({
    slug: "marriage-certificate",
    titleTh: "แปลทะเบียนสมรส (Marriage Certificate / คร.2 คร.3)",
    titleEn: "Certified Translation of a Thai Marriage Certificate",
    officialTh: "ใบสำคัญการสมรส (คร.3) และทะเบียนสมรส (คร.2) ฉบับคัดรับรอง",
    officialEn: "Thai marriage certificate (Kor Ror 3) and marriage register extract (Kor Ror 2)",
    certSystemTh:
      "คู่สมรสวีซ่าออสเตรเลีย: NAATI · สหรัฐฯ/สหราชอาณาจักร: certified translation + Certificate of Accuracy · ยุโรปภาคพื้นทวีป: sworn translator ของประเทศปลายทาง",
    certSystemEn:
      "Australian partner visas: NAATI. US and UK: certified translation with a Certificate of Accuracy. Continental Europe: a sworn translator of the destination country.",
    useCaseTh:
      "ใช้ยื่นวีซ่าคู่สมรส/คู่ครอง เปลี่ยนนามสกุลในต่างประเทศ ขอสวัสดิการคู่สมรส แจ้งสถานะที่สำนักทะเบียนต่างประเทศ และใช้ในคดีครอบครัวหรือการแบ่งทรัพย์สิน",
    useCaseEn:
      "Used for spouse and partner visas, name changes abroad, spousal benefits, foreign civil registry filings, and family or matrimonial property proceedings.",
    prepareTh: [
      "คร.2 และ คร.3 ฉบับคัดรับรองใหม่จากอำเภอ/เขต",
      "หนังสือเดินทางของคู่สมรสทั้งสองฝ่าย",
      "หากเคยหย่า ให้เตรียม คร.6/คร.7 ประกอบด้วย",
    ],
    prepareEn: [
      "Freshly certified Kor Ror 2 and Kor Ror 3 from the district office",
      "Passports of both spouses",
      "Divorce records (Kor Ror 6 / Kor Ror 7) if either party was previously married",
    ],
    pitfallsTh: [
      "ยื่นเฉพาะ คร.3 ทั้งที่ปลายทางขอ คร.2 ซึ่งมีรายละเอียดคู่สมรสครบกว่า",
      "ชื่อ-นามสกุลชาวต่างชาติในทะเบียนไทยสะกดไม่ตรงหนังสือเดินทาง",
      "เอกสารเกินอายุระหว่างรอคิวสถานทูต",
      "แกะแม็กซ์แล้วเย็บใหม่ ทำให้ตราประทับคร่อมหน้าขาด",
    ],
    pitfallsEn: [
      "Submitting only Kor Ror 3 when the authority requires the fuller Kor Ror 2 register extract",
      "Foreign spouse name spellings that do not match the passport",
      "Documents expiring while waiting for an embassy appointment",
      "Removing staples and re-binding, breaking the seal that bridges the pages",
    ],
    nextStepTh:
      "นำคำแปลเข้านิติกรณ์กรมการกงสุล แล้วรับรองที่สถานทูตปลายทาง หากยื่นออสเตรเลียให้ใช้คำแปล NAATI ซึ่งไม่ต้องผ่านกงสุลไทย",
    nextStepEn:
      "Legalise the translation at the Department of Consular Affairs and then at the destination embassy. For Australia, a NAATI translation is used directly and does not go through Thai consular legalisation.",
    turnaroundTh: "แปล 1–2 วันทำการ · NAATI 2–4 วันทำการ · นิติกรณ์เพิ่ม 2–3 วันทำการ",
    turnaroundEn: "1–2 working days; NAATI 2–4 working days; MFA legalisation adds 2–3 working days.",
  }),
  D({
    slug: "house-registration",
    titleTh: "แปลทะเบียนบ้าน (Tabien Baan / ท.ร.14)",
    titleEn: "Certified Translation of a Thai House Registration (Tabien Baan)",
    officialTh: "ทะเบียนบ้าน ท.ร.14 หรือหนังสือรับรองรายการทะเบียนราษฎรจากสำนักทะเบียน",
    officialEn: "House registration book (Tor Ror 14) or a civil registration extract issued by the registrar",
    certSystemTh: "คำรับรองคำแปล + นิติกรณ์กรมการกงสุล · ปลายทางออสเตรเลียใช้ NAATI · ปลายทาง EU ใช้ sworn translator",
    certSystemEn: "Translator's certificate plus MFA legalisation; NAATI for Australia; a sworn translator for EU destinations.",
    useCaseTh:
      "ใช้พิสูจน์ที่อยู่และความสัมพันธ์ในครอบครัวสำหรับวีซ่า การเปิดบัญชีธนาคารต่างประเทศ การลงทะเบียนถิ่นที่อยู่ (เช่น BRP เนเธอร์แลนด์ Anmeldung เยอรมนี) และการยื่นเอกสารมรดก",
    useCaseEn:
      "Used to prove address and family relationships for visas, foreign bank accounts, residence registration (such as BRP in the Netherlands or Anmeldung in Germany) and inheritance filings.",
    prepareTh: [
      "สำเนาทะเบียนบ้านที่นายทะเบียนรับรองสำเนาถูกต้อง (ไม่ใช่ถ่ายเอกสารเอง)",
      "บัตรประชาชนหรือหนังสือเดินทางของเจ้าบ้าน/ผู้มีชื่อในทะเบียน",
      "ระบุว่าปลายทางต้องการเฉพาะหน้ารายการบุคคล หรือทั้งเล่ม",
    ],
    prepareEn: [
      "A registrar-certified copy of the house registration, not a self-made photocopy",
      "Thai ID or passport of the householder or listed person",
      "Whether the destination needs only the person's page or the whole book",
    ],
    pitfallsTh: [
      "ถ่ายสำเนาเองแล้วเซ็นรับรองเอง — กงสุลไม่รับ",
      "แปลเฉพาะหน้าบุคคลทั้งที่ปลายทางขอหน้ารายการบ้านด้วย",
      "แปลชื่อจังหวัด/อำเภอไม่ตรงกับระบบถอดอักษรที่ใช้ในหนังสือเดินทาง",
    ],
    pitfallsEn: [
      "Self-certified photocopies, which the MFA will not accept",
      "Translating only the person page when the address page is also required",
      "Province and district transliterations that differ from the passport's romanisation",
    ],
    nextStepTh: "ยื่นนิติกรณ์กรมการกงสุลพร้อมต้นฉบับ แล้วรับรองต่อที่สถานทูตปลายทางหากปลายทางกำหนด",
    nextStepEn: "Submit the translation with the original for MFA legalisation, then to the destination embassy if required.",
    turnaroundTh: "แปล 1 วันทำการ · นิติกรณ์เพิ่ม 2–3 วันทำการ",
    turnaroundEn: "One working day for translation; MFA legalisation adds 2–3 working days.",
  }),
  D({
    slug: "transcript-diploma",
    titleTh: "แปลทรานสคริปต์และปริญญาบัตร (Transcript & Diploma)",
    titleEn: "Certified Translation of Academic Transcripts and Diplomas",
    officialTh: "ใบแสดงผลการศึกษา (Transcript) และปริญญาบัตร/ประกาศนียบัตรฉบับที่สถานศึกษาออกให้",
    officialEn: "Academic transcript and degree or diploma certificate issued by the institution",
    certSystemTh:
      "สมัครเรียน/เทียบวุฒิ: certified translation · ออสเตรเลีย (VETASSESS, ACS, Engineers Australia, AITSL): NAATI · เนเธอร์แลนด์ (Nuffic/DUO): beëdigd vertaler · เยอรมนี: beeidigter Übersetzer",
    certSystemEn:
      "Certified translation for admissions and credential evaluation; NAATI for Australian skills assessments (VETASSESS, ACS, Engineers Australia, AITSL); beëdigd vertaler for Nuffic/DUO; beeidigter Übersetzer for Germany.",
    useCaseTh:
      "ใช้สมัครมหาวิทยาลัยต่างประเทศ ประเมินทักษะเพื่อขอวีซ่าทักษะ เทียบวุฒิการศึกษา สมัครงานกับนายจ้างต่างชาติ และขอใบประกอบวิชาชีพ",
    useCaseEn:
      "Used for university admissions, skills assessments for skilled visas, credential recognition, foreign employment and professional registration.",
    prepareTh: [
      "ทรานสคริปต์ฉบับจริงที่มีตราประทับและลายเซ็นนายทะเบียนของสถานศึกษา",
      "ปริญญาบัตรฉบับจริงหรือสำเนาที่สถานศึกษารับรอง",
      "ชื่อ-นามสกุลตามหนังสือเดินทาง เพื่อไม่ให้ต่างจากที่สถานศึกษาสะกดไว้",
    ],
    prepareEn: [
      "The original transcript bearing the institution's seal and registrar signature",
      "The original degree certificate or an institution-certified copy",
      "Passport name spelling, in case it differs from the institution's records",
    ],
    pitfallsTh: [
      "เอกสารการศึกษาต้องให้สถานศึกษารับรองก่อนเข้ากงสุล หลายคนข้ามขั้นนี้",
      "ไม่แปลคำอธิบายระบบเกรดและหน่วยกิตด้านหลังทรานสคริปต์",
      "ใช้คำแปลชื่อปริญญาไม่ตรงกับที่หน่วยงานประเมินคุ้นเคย",
      "ส่งไฟล์สแกนซ้ำของ PDF ที่ลงลายเซ็นดิจิทัล ทำให้ตรวจสอบลายเซ็นไม่ผ่าน",
    ],
    pitfallsEn: [
      "Skipping institutional verification before consular legalisation",
      "Leaving the grading-scale and credit notes on the reverse untranslated",
      "Degree titles rendered differently from what the assessing body expects",
      "Re-scanning a digitally signed PDF so the signature can no longer be verified",
    ],
    nextStepTh:
      "ให้สถานศึกษารับรองเอกสาร → แปลและรับรองคำแปล → นิติกรณ์กรมการกงสุล → ยื่นหน่วยงานประเมินหรือสถาบันปลายทาง",
    nextStepEn:
      "Institutional verification, then translation and certification, then MFA legalisation, then submission to the assessing body or institution.",
    turnaroundTh: "แปล 2–4 วันทำการต่อชุด · NAATI 3–5 วันทำการ · นิติกรณ์เพิ่ม 2–3 วันทำการ",
    turnaroundEn: "2–4 working days per set; NAATI 3–5 working days; MFA legalisation adds 2–3 working days.",
  }),
  D({
    slug: "police-clearance",
    titleTh: "แปลหนังสือรับรองความประพฤติ (Police Clearance Certificate)",
    titleEn: "Certified Translation of a Thai Police Clearance Certificate",
    officialTh: "หนังสือรับรองความประพฤติที่ออกโดยกองบัญชาการตำรวจสันติบาล สำนักงานตำรวจแห่งชาติ",
    officialEn: "Police clearance certificate issued by the Royal Thai Police Special Branch",
    certSystemTh: "ปลายทางออสเตรเลีย: NAATI · ปลายทางอื่น: certified translation + นิติกรณ์กรมการกงสุล + สถานทูตปลายทาง",
    certSystemEn: "NAATI for Australia; elsewhere a certified translation with MFA legalisation and destination embassy attestation.",
    useCaseTh:
      "ใช้ยื่นวีซ่าถาวร วีซ่าคู่สมรส วีซ่าทักษะ การขอสัญชาติ การสมัครงานที่ต้องตรวจประวัติ และการขอใบประกอบวิชาชีพในต่างประเทศ",
    useCaseEn:
      "Used for permanent residence, partner and skilled visas, citizenship applications, background-checked employment and professional registration abroad.",
    prepareTh: [
      "หนังสือรับรองความประพฤติฉบับจริง (มักออกเป็นภาษาอังกฤษอยู่แล้ว — ตรวจว่าปลายทางต้องการคำแปลเพิ่มหรือไม่)",
      "หนังสือเดินทางที่ใช้ตอนขอเอกสาร",
      "วันนัดยื่นวีซ่า เพื่อวางแผนไม่ให้เอกสารหมดอายุ",
    ],
    prepareEn: [
      "The original certificate (often already issued in English — confirm whether a translation is needed at all)",
      "The passport used when the certificate was issued",
      "Your visa appointment date, so the certificate does not expire first",
    ],
    pitfallsTh: [
      "เอกสารประเภทนี้อายุสั้น หลายปลายทางรับเฉพาะฉบับที่ออกไม่เกิน 3–6 เดือน",
      "ขอแปลทั้งที่ต้นฉบับเป็นภาษาอังกฤษอยู่แล้ว ทำให้เสียเวลาและค่าใช้จ่ายโดยไม่จำเป็น",
      "ตัวสะกดชื่อในเอกสารต่างจากหนังสือเดินทางเล่มปัจจุบัน",
    ],
    pitfallsEn: [
      "Short validity — many authorities accept only certificates issued within 3–6 months",
      "Ordering a translation when the original is already in English",
      "Name spelling that differs from the current passport",
    ],
    nextStepTh: "นิติกรณ์กรมการกงสุล แล้วรับรองที่สถานทูตปลายทางหากกำหนด — ทำใกล้วันยื่นเพื่อไม่ให้เกินอายุ",
    nextStepEn: "MFA legalisation and, if required, destination embassy attestation — do this close to the submission date.",
    turnaroundTh: "แปล 1 วันทำการ · นิติกรณ์เพิ่ม 2–3 วันทำการ",
    turnaroundEn: "One working day for translation; MFA legalisation adds 2–3 working days.",
  }),
  D({
    slug: "bank-statement",
    titleTh: "แปลเอกสารการเงิน (Bank Statement / หนังสือรับรองเงินฝาก)",
    titleEn: "Certified Translation of Bank Statements and Financial Documents",
    officialTh: "Statement บัญชีธนาคาร หนังสือรับรองยอดเงินฝาก หนังสือรับรองเงินเดือน และแบบ ภ.ง.ด.",
    officialEn: "Bank statements, bank balance confirmation letters, salary certificates and Thai tax returns (Por Ngor Dor)",
    certSystemTh: "certified translation + คำรับรองคำแปล · ปลายทางบางแห่งขอนิติกรณ์กรมการกงสุลเพิ่ม",
    certSystemEn: "Certified translation with a certificate of accuracy; some authorities additionally require MFA legalisation.",
    useCaseTh:
      "ใช้พิสูจน์ความสามารถทางการเงินสำหรับวีซ่าท่องเที่ยว วีซ่านักเรียน วีซ่าเกษียณ การค้ำประกันผู้ติดตาม และการยื่นสินเชื่อหรือซื้ออสังหาริมทรัพย์ในต่างประเทศ",
    useCaseEn:
      "Used to evidence funds for tourist, student and retirement visas, sponsorship of dependants, and foreign loan or property applications.",
    prepareTh: [
      "Statement ที่ธนาคารออกและประทับตรา (ไม่ใช่ภาพหน้าจอแอป)",
      "หนังสือรับรองยอดเงินฝากฉบับภาษาอังกฤษจากธนาคาร หากธนาคารออกให้ได้",
      "ระบุจำนวนเดือนย้อนหลังที่ปลายทางกำหนด (มัก 3–6 เดือน)",
    ],
    prepareEn: [
      "Bank-issued and stamped statements, not app screenshots",
      "An English bank confirmation letter if the bank can issue one",
      "The number of months the destination requires, typically 3–6",
    ],
    pitfallsTh: [
      "ใช้ภาพหน้าจอจากแอปธนาคาร ซึ่งสถานทูตส่วนใหญ่ไม่รับ",
      "ยอดเงินเข้าออกผิดปกติก่อนยื่นโดยไม่มีคำอธิบาย",
      "แปลไม่ครบทุกหน้า ทำให้ยอดยกมาไม่ต่อเนื่อง",
    ],
    pitfallsEn: [
      "App screenshots, which most embassies reject",
      "Unexplained large deposits shortly before submission",
      "Partial translations that break the running balance",
    ],
    nextStepTh: "หากปลายทางกำหนด ให้นำคำแปลเข้านิติกรณ์กรมการกงสุลก่อนยื่นสถานทูต",
    nextStepEn: "If required, take the translation through MFA legalisation before the embassy submission.",
    turnaroundTh: "แปล 1–3 วันทำการ ขึ้นกับจำนวนหน้า",
    turnaroundEn: "1–3 working days depending on page count.",
  }),
  D({
    slug: "company-affidavit",
    titleTh: "แปลหนังสือรับรองบริษัท (DBD Company Affidavit / บอจ.5)",
    titleEn: "Certified Translation of Thai Company Documents (DBD Affidavit, Shareholder List)",
    officialTh: "หนังสือรับรองนิติบุคคลจากกรมพัฒนาธุรกิจการค้า (DBD) บัญชีรายชื่อผู้ถือหุ้น (บอจ.5) และงบการเงิน",
    officialEn: "Company affidavit from the Department of Business Development (DBD), shareholder list (Bor Or Jor 5) and financial statements",
    certSystemTh: "certified translation + นิติกรณ์กรมการกงสุล + สถานทูตปลายทาง (สำหรับใช้ต่างประเทศ)",
    certSystemEn: "Certified translation, MFA legalisation and destination embassy attestation for overseas use.",
    useCaseTh:
      "ใช้เปิดบริษัทลูกหรือสาขาในต่างประเทศ เปิดบัญชีธนาคารนิติบุคคล ประมูลงาน ทำสัญญาการค้า จดเครื่องหมายการค้า และยื่นวีซ่าธุรกิจให้กรรมการหรือพนักงาน",
    useCaseEn:
      "Used to establish overseas subsidiaries or branches, open corporate accounts, bid for contracts, execute trade agreements, register trademarks and support business visas.",
    prepareTh: [
      "หนังสือรับรอง DBD ฉบับคัดใหม่ (ปลายทางส่วนใหญ่รับไม่เกิน 6 เดือน)",
      "บอจ.5 ฉบับล่าสุดที่ยื่นต่อ DBD",
      "ชื่อบริษัทภาษาอังกฤษที่จดทะเบียนไว้ เพื่อให้คำแปลตรงกับเอกสารเดิม",
    ],
    prepareEn: [
      "A recent DBD affidavit, usually accepted within six months of issue",
      "The latest shareholder list filed with the DBD",
      "The company's registered English name so the translation matches earlier filings",
    ],
    pitfallsTh: [
      "แปลชื่อบริษัทไม่ตรงกับชื่ออังกฤษที่จดทะเบียนไว้กับ DBD",
      "หนังสือรับรองเกิน 6 เดือน ณ วันยื่น",
      "ไม่แปลรายการวัตถุประสงค์ทั้งหมดตามที่ปลายทางกำหนด",
    ],
    pitfallsEn: [
      "A company name translated differently from the registered English name",
      "An affidavit older than six months at submission",
      "Omitting the full list of business objectives when the destination requires it",
    ],
    nextStepTh: "แปล → นิติกรณ์กรมการกงสุล → สถานทูตปลายทาง หรือหอการค้าปลายทางกรณีเอกสารการค้า",
    nextStepEn: "Translation, MFA legalisation, then the destination embassy or chamber of commerce for trade documents.",
    turnaroundTh: "แปล 2–3 วันทำการ · นิติกรณ์เพิ่ม 2–3 วันทำการ",
    turnaroundEn: "2–3 working days for translation; MFA legalisation adds 2–3 working days.",
  }),
  D({
    slug: "court-judgment",
    titleTh: "แปลคำพิพากษาและคำสั่งศาล (Court Judgment / Divorce Decree)",
    titleEn: "Certified Translation of Thai Court Judgments and Orders",
    officialTh: "คำพิพากษา คำสั่งศาล บันทึกข้อตกลงการหย่า และคำสั่งอำนาจปกครองบุตร ฉบับที่ศาลรับรองสำเนาถูกต้อง",
    officialEn: "Court judgments, orders, divorce settlement records and custody orders, certified as true copies by the court",
    certSystemTh:
      "ใช้ในศาลไทย: ผู้แปลขึ้นทะเบียนกระทรวงยุติธรรม · ใช้ต่างประเทศ: certified/sworn translation ตามระบบของประเทศปลายทาง + นิติกรณ์",
    certSystemEn:
      "For Thai court use, a Ministry of Justice listed translator; for overseas use, a certified or sworn translation per the destination's system plus legalisation.",
    useCaseTh:
      "ใช้ขอรับรองการหย่าในต่างประเทศ ยื่นเรื่องอำนาจปกครองบุตร บังคับคดีข้ามประเทศ ยื่นวีซ่าที่ต้องแสดงสถานภาพ และการจัดการมรดก",
    useCaseEn:
      "Used for recognition of divorce abroad, custody filings, cross-border enforcement, visas requiring proof of status and estate administration.",
    prepareTh: [
      "สำเนาคำพิพากษาที่ศาลรับรองพร้อมหนังสือรับรองคดีถึงที่สุด หากปลายทางกำหนด",
      "เลขคดีและชื่อคู่ความตามที่ปรากฏในคำพิพากษา",
      "หนังสือเดินทางของคู่ความเพื่อยืนยันตัวสะกดชื่อ",
    ],
    prepareEn: [
      "A court-certified copy of the judgment, with a certificate of finality if required",
      "The case number and party names exactly as they appear",
      "Passports of the parties to confirm name spellings",
    ],
    pitfallsTh: [
      "ไม่แนบหนังสือรับรองคดีถึงที่สุด ทำให้ปลายทางไม่รับรองการหย่า",
      "แปลศัพท์กฎหมายไทยแบบตรงตัวจนความหมายเปลี่ยน",
      "ใช้ผู้แปลที่ไม่ได้ขึ้นทะเบียนกระทรวงยุติธรรมสำหรับงานที่จะใช้ในศาลไทย",
    ],
    pitfallsEn: [
      "Omitting the certificate of finality, so the foreign authority will not recognise the divorce",
      "Literal renderings of Thai legal terms that change the meaning",
      "Using a translator not listed with the Ministry of Justice for Thai court filings",
    ],
    nextStepTh: "แปลโดยผู้แปลที่เหมาะกับปลายทาง → นิติกรณ์กรมการกงสุล → สถานทูตหรือศาลปลายทาง",
    nextStepEn: "Translate with the correct translator type, legalise at the MFA, then submit to the destination embassy or court.",
    turnaroundTh: "แปล 3–7 วันทำการ ขึ้นกับความยาวคำพิพากษา",
    turnaroundEn: "3–7 working days depending on the length of the judgment.",
  }),
  D({
    slug: "power-of-attorney",
    titleTh: "แปลหนังสือมอบอำนาจ (Power of Attorney)",
    titleEn: "Certified Translation of a Power of Attorney",
    officialTh: "หนังสือมอบอำนาจทั่วไปหรือเฉพาะการ ที่ผ่านการรับรองลายมือชื่อโดยทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร",
    officialEn: "General or special power of attorney, with the signature witnessed by a notarial services attorney",
    certSystemTh: "certified/sworn translation ตามปลายทาง — เอกสารเอกชนต้องรับรองลายมือชื่อก่อนเข้านิติกรณ์เสมอ",
    certSystemEn: "Certified or sworn translation per the destination; as a private document it must be notarised before legalisation.",
    useCaseTh:
      "ใช้มอบอำนาจขายหรือโอนทรัพย์สินข้ามประเทศ ปิดบัญชีธนาคาร จัดการมรดก ยื่นภาษี และดำเนินการแทนในบริษัทต่างประเทศ",
    useCaseEn:
      "Used to authorise cross-border property transfers, bank account closures, estate administration, tax filings and corporate acts abroad.",
    prepareTh: [
      "ร่างหนังสือมอบอำนาจแบบที่ปลายทางกำหนด — อย่าลงลายมือชื่อมาก่อน",
      "หนังสือเดินทางหรือบัตรประชาชนตัวจริงของผู้มอบอำนาจ",
      "รายละเอียดธุรกรรม เช่น เลขโฉนด เลขบัญชี หรือเลขทะเบียนบริษัท",
    ],
    prepareEn: [
      "The destination's required POA template — do not pre-sign it",
      "The grantor's original passport or Thai ID",
      "Transaction details such as deed, account or company registration numbers",
    ],
    pitfallsTh: [
      "ลงลายมือชื่อก่อนพบทนาย ทำให้รับรองลายมือชื่อไม่ได้",
      "ขอบเขตอำนาจกว้างเกินไป หลายประเทศไม่ยอมรับ",
      "แปลผิดคำเดียวในข้อความมอบอำนาจ ทำให้ถูกตีกลับทั้งฉบับ",
    ],
    pitfallsEn: [
      "Signing before meeting the attorney, which makes witnessing impossible",
      "Overly broad authority, which many jurisdictions reject",
      "A single mistranslated clause can invalidate the whole instrument",
    ],
    nextStepTh: "รับรองลายมือชื่อโดยทนาย → แปลและรับรองคำแปล → นิติกรณ์กรมการกงสุล → สถานทูตปลายทาง",
    nextStepEn: "Notarise the signature, translate and certify, legalise at the MFA, then attest at the destination embassy.",
    turnaroundTh: "รับรองลายมือชื่อวันเดียว · แปล 1–2 วันทำการ · นิติกรณ์เพิ่ม 2–3 วันทำการ",
    turnaroundEn: "Same-day notarisation; 1–2 working days for translation; MFA legalisation adds 2–3 working days.",
  }),
  D({
    slug: "medical-certificate",
    titleTh: "แปลใบรับรองแพทย์และประวัติการรักษา (Medical Records)",
    titleEn: "Certified Translation of Medical Certificates and Records",
    officialTh: "ใบรับรองแพทย์ที่ระบุเลขใบประกอบวิชาชีพเวชกรรม (เลข ว.) ประวัติการรักษา และสมุดวัคซีน",
    officialEn: "Medical certificates showing the physician's licence number, treatment records and vaccination books",
    certSystemTh: "certified translation โดยผู้แปลที่มีประสบการณ์ศัพท์การแพทย์ · บางปลายทางขอนิติกรณ์เพิ่ม",
    certSystemEn: "Certified translation by a translator experienced in medical terminology; some authorities also require legalisation.",
    useCaseTh:
      "ใช้ยื่นวีซ่าที่ต้องตรวจสุขภาพ เคลมประกันสุขภาพต่างประเทศ ส่งต่อการรักษาข้ามประเทศ ขอลาป่วยกับนายจ้างต่างชาติ และยื่นสิทธิประโยชน์ทุพพลภาพ",
    useCaseEn:
      "Used for visa health requirements, foreign insurance claims, cross-border referrals, sick leave with foreign employers and disability benefit claims.",
    prepareTh: [
      "ใบรับรองแพทย์ตัวจริงที่มีตราโรงพยาบาลและเลข ว. ของแพทย์",
      "ประวัติการรักษาที่โรงพยาบาลออกให้อย่างเป็นทางการ",
      "ระบุชื่อบริษัทประกันหรือหน่วยงานที่จะยื่น",
    ],
    prepareEn: [
      "The original certificate with the hospital seal and the doctor's licence number",
      "Officially issued treatment records from the hospital",
      "The insurer or authority the documents will be submitted to",
    ],
    pitfallsTh: [
      "ใบรับรองแพทย์ไม่มีเลข ว. ทำให้ปลายทางไม่รับ",
      "แปลชื่อยาและรหัสวินิจฉัย (ICD) ไม่ตรงมาตรฐานสากล",
      "ใบรับรองแพทย์หลายปลายทางกำหนดอายุไม่เกิน 30 วัน",
    ],
    pitfallsEn: [
      "Certificates lacking the physician's licence number",
      "Drug names and ICD codes not matched to international standards",
      "Many authorities accept medical certificates issued within 30 days only",
    ],
    nextStepTh: "ยื่นคำแปลต่อบริษัทประกันหรือหน่วยงานปลายทาง หากปลายทางกำหนดให้เพิ่มนิติกรณ์กรมการกงสุล",
    nextStepEn: "Submit to the insurer or authority; add MFA legalisation only if the destination requires it.",
    turnaroundTh: "แปล 1–3 วันทำการ ขึ้นกับความยาวประวัติการรักษา",
    turnaroundEn: "1–3 working days depending on record length.",
  }),
  D({
    slug: "driving-licence",
    titleTh: "แปลใบขับขี่ไทย (Thai Driving Licence)",
    titleEn: "Certified Translation of a Thai Driving Licence",
    officialTh: "ใบอนุญาตขับรถของกรมการขนส่งทางบก และใบขับขี่สากล (International Driving Permit)",
    officialEn: "Thai driving licence issued by the Department of Land Transport, and the International Driving Permit",
    certSystemTh: "certified translation · บางประเทศ (เยอรมนี ญี่ปุ่น) ต้องแปลโดยผู้แปลที่หน่วยงานท้องถิ่นรับรองเท่านั้น",
    certSystemEn: "Certified translation; some countries such as Germany and Japan accept only translators approved by the local authority.",
    useCaseTh:
      "ใช้แลกใบขับขี่ในต่างประเทศ เช่ารถระยะยาว ซื้อประกันรถ และยื่นเป็นเอกสารยืนยันตัวตนประกอบใบสมัครถิ่นที่อยู่",
    useCaseEn:
      "Used to exchange a licence abroad, rent vehicles long term, buy motor insurance and support residence applications.",
    prepareTh: [
      "ใบขับขี่ตัวจริงที่ยังไม่หมดอายุ",
      "หนังสือรับรองประวัติการถือใบขับขี่จากกรมการขนส่งทางบก หากปลายทางขอ",
      "หนังสือเดินทางเพื่อยืนยันตัวสะกดชื่อ",
    ],
    prepareEn: [
      "A valid, unexpired Thai licence",
      "A licence history certificate from the Department of Land Transport if requested",
      "Your passport to confirm name spelling",
    ],
    pitfallsTh: [
      "ไม่แปลข้อมูลด้านหลังบัตร เช่น ประเภทรถและข้อจำกัด",
      "ใบขับขี่หมดอายุก่อนวันแลกในต่างประเทศ",
      "บางประเทศรับเฉพาะคำแปลจากผู้แปลที่หน่วยงานท้องถิ่นกำหนด — ต้องตรวจก่อนสั่งแปลในไทย",
    ],
    pitfallsEn: [
      "Leaving the reverse side, including vehicle classes and restrictions, untranslated",
      "A licence that expires before the exchange appointment",
      "Countries that accept only locally approved translators — check before ordering in Thailand",
    ],
    nextStepTh: "ยื่นคำแปลพร้อมต้นฉบับต่อหน่วยงานขนส่งปลายทาง เพิ่มนิติกรณ์เฉพาะกรณีที่ปลายทางกำหนด",
    nextStepEn: "Submit the translation with the original to the destination transport authority; legalise only if required.",
    turnaroundTh: "แปลเสร็จภายใน 1 วันทำการ",
    turnaroundEn: "Completed within one working day.",
  }),
  D({
    slug: "single-status",
    titleTh: "แปลหนังสือรับรองความเป็นโสด (Certificate of Single Status)",
    titleEn: "Certified Translation of a Thai Certificate of Single Status",
    officialTh: "หนังสือรับรองความเป็นโสด / หนังสือรับรองสถานภาพสมรส ที่ออกโดยสำนักทะเบียนอำเภอหรือเขต",
    officialEn: "Certificate of single status or marital status certificate issued by the district registrar",
    certSystemTh: "certified/sworn translation ตามประเทศที่จะจดทะเบียนสมรส + นิติกรณ์กรมการกงสุล + สถานทูตปลายทาง",
    certSystemEn: "Certified or sworn translation per the country of marriage, plus MFA legalisation and embassy attestation.",
    useCaseTh:
      "ใช้จดทะเบียนสมรสในต่างประเทศ ยื่นขอวีซ่าคู่หมั้น และยื่นต่อสำนักทะเบียนหรือศาลครอบครัวปลายทาง",
    useCaseEn:
      "Used to register a marriage abroad, apply for fiancé visas and file with foreign registries or family courts.",
    prepareTh: [
      "หนังสือรับรองความเป็นโสดฉบับคัดใหม่ (ส่วนใหญ่ปลายทางรับไม่เกิน 3–6 เดือน)",
      "หากเคยสมรสหรือหย่า ต้องแนบ คร.6/คร.7 หรือมรณบัตรของคู่สมรสเดิม",
      "ชื่อและข้อมูลคู่หมั้นตามหนังสือเดินทาง",
    ],
    prepareEn: [
      "A recently issued certificate, usually valid 3–6 months at the destination",
      "Divorce records or the former spouse's death certificate if previously married",
      "The fiancé(e)'s details exactly as in their passport",
    ],
    pitfallsTh: [
      "เอกสารหมดอายุระหว่างรอคิวสถานทูตหรือสำนักทะเบียนปลายทาง",
      "ไม่แนบเอกสารการหย่าครั้งก่อน ทำให้ปลายทางไม่รับ",
      "ใช้ระบบแปลผิดประเทศ เช่น ยื่นเยอรมนีโดยไม่ใช้ beeidigter Übersetzer",
    ],
    pitfallsEn: [
      "Expiry while waiting for the embassy or destination registry",
      "Missing prior divorce documentation",
      "Using the wrong translation system, such as filing in Germany without a beeidigter Übersetzer",
    ],
    nextStepTh: "แปลและรับรองคำแปล → นิติกรณ์กรมการกงสุล → สถานทูตปลายทาง → ยื่นสำนักทะเบียนที่จะจดทะเบียนสมรส",
    nextStepEn: "Translate and certify, legalise at the MFA, attest at the embassy, then file with the marriage registry.",
    turnaroundTh: "แปล 1 วันทำการ · นิติกรณ์เพิ่ม 2–3 วันทำการ",
    turnaroundEn: "One working day for translation; MFA legalisation adds 2–3 working days.",
  }),
];

export const TRANSLATION_DOC_SLUGS = TRANSLATION_DOC_LANDINGS.map((d) => d.slug);

export function getTranslationDocLanding(slug: string): TranslationDocLanding | undefined {
  return TRANSLATION_DOC_LANDINGS.find((d) => d.slug === slug);
}